module.exports = __webpack_public_path__ + "static/media/paypalBtn.e3a24f58.png";